import { Product } from '../types';

export interface ProductCardItem {
  product: Product;
  color?: string;
  colorImage?: string;
}

/**
 * Expands a product into individual product-card entries — one per available
 * (in-stock) color variant. Products with a single colour (or no colour data)
 * stay as one card. Out-of-stock colours are never duplicated as separate cards.
 */
export function expandProductCards(product: Product): ProductCardItem[] {
  const colors = (product.color_variants || []).filter(cv => cv.in_stock);
  if (colors.length <= 1) {
    return [{ product }];
  }
  return colors.map(cv => ({
    product,
    color: cv.color,
    colorImage: cv.image || undefined,
  }));
}

/** Build a product-detail URL for a specific colour, or the plain URL. */
export function productUrl(product: Product, color?: string): string {
  const base = `/products/${product.slug}`;
  if (!color) return base;
  return `${base}?color=${encodeURIComponent(color)}`;
}